<template>
  <navigation-view />

  <section>
    <div class="w-full px-5 pb-5">
      <div class="max-w-5xl mx-auto w-full">
        <ol class="flex gap-2 pt-4 pl-3 font-normal text-[#001c54]">
          <li><a href="/">Home</a></li>
          <li>> Refund Policy</li>
        </ol>


        <h1 class="lg:text-2xl lg:pt-2 pt-12 py-2 font-bold text-[18px] sm:text-[18px]">
          Refund Policy
        </h1>

        <section class="mb-6 text-left">
          <h2 class="text-xl font-semibold text-gray-700 mb-2">Scope</h2>
          <p class="text-gray-600">
            The refund policy lays out complete information and guidance about the fee refund process applicable to
            learners,
            the process of applying for refunds and the conditions under which refunds will be provided.
          </p>
          <p class="text-gray-600 mt-2">
            This policy is applicable for all learners enrolled in the online programs offered by the Centre for
            Distance and Online Education.
          </p>
        </section>

        <section class="mb-1 text-left">
          <h2 class="text-xl font-semibold text-gray-700 mb-2">Circumstances for Processing a Refund</h2>

          <ul class="list-disc list-inside text-gray-600 space-y-2">
            <li>
              <strong>Admission rejected by the University:</strong>
              A complete refund of Program Fee, Registration Fee, and Examination Fee will be made.
            </li>
            <li>
              <strong>Program Cancelled / Withdrawn by University:</strong>
              A complete refund of Program Fee, Registration Fee, and Examination Fee will be made.
            </li>
            <li>
              <strong>Learner Requested for a Refund:</strong>
              In case of a request from a learner for cancellation of admission and refund of fees, the following table
              will be applicable:
            </li>
          </ul>
        </section>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg border-collapse border border-slate-300">

          <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-[#95C24D] text-white">
              <tr>
                <th scope="col" class="px-6 py-3 border border-slate-300 w-1/2">
                  Time when refund request made
                </th>
                <th scope="col" class="px-6 py-3 border border-slate-300">
                  Amount of Refund Applicable
                </th>

              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="px-6 py-4 border border-slate-300">
                  More than 15 days prior to the notified last date of admission
                </td>
                <td class="px-6 py-4 border border-slate-300">
                  Refund of 90% of Program Fee and Full Examination Fee
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 border border-slate-300">
                  Within 15 days after the notified last date of admission
                </td>
                <td class="px-6 py-4 border border-slate-300">
                  Refund of 80% of Program Fee and Full Examination Fee
                </td>

              </tr>
              <tr>

                <td class="px-6 py-4 border border-slate-300">
                  Between 15 days and 30 days after the notified last date of admission
                </td>
                <td class="px-6 py-4 border border-slate-300">
                  Refund of 50% of Program Fee and Full Examination Fee
                </td>

              </tr>
              <tr>

                <td class="px-6 py-4 border border-slate-300">
                  More than 30 days after the notified last date of admission
                </td>
                <td class="px-6 py-4 border border-slate-300">
                  No Refund
                </td>

              </tr>


            </tbody>
          </table>
        </div>
        <section class="mb-6 text-left">
          <h2 class="text-xl font-semibold text-gray-700 mb-2">Procedure for Refund:</h2>

          <ul class="list-disc list-inside text-gray-600 space-y-2 mb-2">
            <li class="flex gap-4 p-2">
              <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
              Refund request must be raised online on the VISA portal by the learner through by filling the refund form
              and providing complete details and supporting documents.
            </li>
            <li class="flex gap-4 p-2">
              <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
              Refund request will be verified within 48 hours of receipt of the application and will be sent for further
              process.
            </li>
            <li class="flex gap-4 p-2">
              <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
              In case fees paid through loan assistance, the loan company will be intimated to stop further EMIs and
              initiate the refund of EMIs already debited up to the extent of eligible refund amount.
            </li>
            <li class="flex gap-4 p-2">
              <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
              Refund will be made within 25 days of the approval of refund.
            </li>
            <li class="flex gap-4 p-2">
              <img src="../assets/Programpage/Eligibility/blue_bullet.webp" alt class="h-5" />
              The details of the refund made will be shared with the learner.
            </li>
          </ul>
          <p>Refund requests shall be processed within 30 working days post the confirmation of academics team.</p>
          <p class="text-[13px] lg:text-[19px] font-semibold text-gray-700 mb-2 mt-2 leading-[22px] lg:leading-[32px]">NOTE: For any refund-related enquiries, you may contact
            the Email ID <a class="text-[#81c8dc]" href="mailto:learnersupport@onlineyenepoya.com"
              target="_blank">learnersupport@onlineyenepoya.com</a><br><span class="font-semibold text-gray-700 mt-3">The refund will be processed within a period of 60 to 90 working days from the date of approval.</span> </p>
        </section>
      </div>
    </div>
  </section>
  <footer-view />
</template>

<script>
import NavigationView from "../components/NavigationView.vue";
import FooterView from "../components/FooterView.vue";
export default {
  components: {
    NavigationView,
    FooterView,
  },

}
</script>

<style></style>